import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SideMenu from "../../Components/SideMenu";
import { Button } from "react-bootstrap";
import {
  contactDelete,
  contactList,
} from "../../reducers/commonReducer";
import { home } from "../../const";

const ContactList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!localStorage.getItem("x-auth-token")) {
      navigate(home);
    }
    dispatch(contactList());
  }, []);

  const { getContactList } = useSelector((state) => state.commonReducer);
  return (
    <>
      <SideMenu />
      <div className="mt-extra content container-fluid">
        <table className="table w-100">
          <thead className="normalplace">
            <tr>
              <th className="over-col-size">Sr</th>
              <th className="over-col-size">Name</th>
              <th className="over-col-size">Phone</th>
              <th className="over-col-size">Email</th>
              <th className="over-col-size">Message</th>
              <th className="over-col-size">Action</th>
            </tr>
          </thead>
          <tbody>
            {!!getContactList &&
              getContactList?.map((data, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}.</td>
                    <td>{data?.name}</td>
                    <td>{data?.phone}</td>
                     <td>{data?.email}</td>
                    <td>{data?.message}</td>
                    <td>
                      <Button
                        className="m-1"
                        variant="danger"
                        onClick={async () => {
                          const apiResp = await dispatch(contactDelete(data?.id));
                          if(apiResp?.payload?.status){
                            await dispatch(contactList());
                          }
                        }}
                      >
                        <i className="bi bi-trash"></i>
                      </Button>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ContactList;
